import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api';
import { GC_TIMES, STALE_TIMES } from './constants';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIMES.short,
      gcTime: GC_TIMES.default,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if ([401, 403, 404, 429].includes(error.status)) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
